import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=26e8a484&scoped=true"
import script from "./MaterialForm.vue?vue&type=script&lang=js"
export * from "./MaterialForm.vue?vue&type=script&lang=js"
import style0 from "./MaterialForm.vue?vue&type=style&index=0&id=26e8a484&prod&lang=scss&scoped=true"
import style1 from "./MaterialForm.vue?vue&type=style&index=1&id=26e8a484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e8a484",
  null
  
)

export default component.exports